import React from 'react';

/**
 * ErrorBoundary — Capture les erreurs React non gérées (Sprint Frontend B5).
 *
 * Class component (seul moyen React 18 d'implémenter componentDidCatch).
 * Wrap l'arbre entier dans App.js pour éviter qu'un crash composant
 * affiche un écran blanc à l'agent/admin.
 *
 * En dev : affiche la stack. En prod : message rassurant + bouton recharger.
 * TODO observability : envoyer à Sentry / logging service.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log to console (production : envoyer à Sentry / observability)
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: 40,
          fontFamily: 'system-ui, sans-serif',
          textAlign: 'center',
          maxWidth: 600,
          margin: '60px auto',
          background: '#FFF8F0',
          borderRadius: 12,
          border: '1px solid #E0DDD8',
        }}>
          <h1 style={{ color: '#5A3C1F', fontSize: 24, marginBottom: 12 }}>
            Une erreur est survenue
          </h1>
          <p style={{ color: '#6B5847', marginBottom: 24 }}>
            Pas de panique — rechargez la page pour continuer.
          </p>
          <button
            onClick={this.handleReload}
            style={{
              padding: '12px 32px',
              fontSize: 16,
              background: '#A0763E',
              color: 'white',
              border: 'none',
              borderRadius: 8,
              cursor: 'pointer',
              fontWeight: 600,
            }}
          >
            Recharger la page
          </button>
          {process.env.NODE_ENV !== 'production' && this.state.error && (
            <pre style={{
              marginTop: 24,
              padding: 16,
              background: '#F5EFE6',
              borderRadius: 6,
              textAlign: 'left',
              fontSize: 12,
              color: '#5A3C1F',
              overflow: 'auto',
              maxHeight: 200,
            }}>
              {String(this.state.error?.stack || this.state.error)}
            </pre>
          )}
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
